import { render, staticRenderFns } from "./memorabilia.vue?vue&type=template&id=6327d9a4&scoped=true"
import script from "./memorabilia.vue?vue&type=script&lang=js"
export * from "./memorabilia.vue?vue&type=script&lang=js"
import style0 from "./memorabilia.vue?vue&type=style&index=0&id=6327d9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6327d9a4",
  null
  
)

export default component.exports